import { Avatar } from "@mui/material";
import commonStyles from "styles/common";

const UserAvatar = (props: { userName: any; onClick?: any }) => {
    const { userName, onClick } = props;
    const { classes: common } = commonStyles();
    return (
        <Avatar
            className={common.middleCenter}
            style={{
                width: 48,
                height: 48,
                background: "linear-gradient(113deg, #DD5900 1.06%, #F8962F 100%)",
                boxShadow: "0px -1px 0px 0px rgba(0, 0, 0, 0.05) inset",
                color: "#FFFFFF",
                cursor: onClick ? "pointer" : "",
            }}
            onClick={onClick}
        >
            {userName[0].toUpperCase()}
        </Avatar>
    );
};

export default UserAvatar;
